import { closeModalByName, ExitModal, ExitModalProps } from 'ia-react-core';
import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StyledIcon } from './LogOffQuitFormModal.styles';
import redirectTo from '../../utils/redirectTo';

export interface LogOffQuitFormModalProps extends ExitModalProps {
  logoffPage: string;
}

export const LogOffQuitFormModalName = 'LogOffQuitFormModal';

const LogOffQuitFormModal: FC<LogOffQuitFormModalProps> = ({ logoffPage, ...props }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('LogOffQuitFormModal');

  return (
    <ExitModal
      Icon={StyledIcon}
      name={LogOffQuitFormModalName}
      onCancel={() => redirectTo(logoffPage, navigate)}
      onConfirm={() => dispatch(closeModalByName(LogOffQuitFormModalName))}
      modalTitle={t('modalTitle')}
      modalMessage={t('modalMessage')}
      confirmButton={t('notNow')}
      cancelButton={t('exit')}
      {...props}
    />
  );
};
export default LogOffQuitFormModal;
